import {FormContainer, FormattedAlert, FormattedButton, LoadingIcon} from "@dvrt/graphql-widgets";
import {useStyles} from "@/components/call-group/members/styles";
import {Link} from "@/components/widgets";
import {Page} from "@/components/pages";
import {ContextFilters, useAuth} from "@/context/AuthProvider";
import {useDomainNameQuery} from "@/queries.generated";
import {Permission} from "@/authSchema";
import {defineMessage, MessageDescriptor} from "react-intl";

type Props = {
    message: MessageDescriptor;
    messageNoPermission: MessageDescriptor;
    link: string;
    permission: Permission;
    domainId: number;
};

const NoRequiredData = ({message, messageNoPermission, link, permission, domainId}: Props) => {
    const auth = useAuth();
    const {data: domainNameData, loading} = useDomainNameQuery({
        variables: {
            id: domainId,
        },
    });
    const {classes} = useStyles();

    if (loading) return <LoadingIcon />;

    const domainName = domainNameData.domains.items[0].name;
    const hasPermission = auth.hasPermission(permission, ContextFilters.domain(domainName));

    return (
        <Page title={defineMessage({id: "gatewayRouting.pageTitle", defaultMessage: "Routing"})}>
            <FormContainer>
                <div className={classes.noMembersContainer}>
                    <FormattedAlert message={hasPermission ? message : messageNoPermission} severity="info" />
                    {auth.hasPermission(permission, ContextFilters.domain(domainName)) && (
                        <Link to={link}>
                            <FormattedButton
                                message={defineMessage({id: "gatewayRouting.buttons.add", defaultMessage: "Add"})}
                                variant="contained"
                                color="primary"
                                style={{marginLeft: "1em"}}
                            />
                        </Link>
                    )}
                </div>
            </FormContainer>
        </Page>
    );
};

export default NoRequiredData;
